import React from "react";
import OwnerSidebar, { OwnerMobileBar } from "@/components/OwnerSidebar";

export default function OwnerLayout({ children }) {
  return (
    <div className="min-h-screen flex bg-background text-foreground">
      <OwnerSidebar />
      <div className="flex-1 min-w-0 flex flex-col">
        <OwnerMobileBar />
        {/* spacer for mobile sub-nav row */}
        <div className="md:hidden h-10" />
        <main className="flex-1 min-w-0">{children}</main>
      </div>
    </div>
  );
}
